module.exports = __webpack_public_path__ + "e9a0c4c60b7436987c96524817bd6579.png";